import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMuseumSlugFromEmail } from '@/features/museum/utils/museum';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const { museumSlug } = useParams<{ museumSlug?: string }>();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!user) {
    const loginPath = museumSlug ? `/${museumSlug}/login` : '/login';
    return <Navigate to={loginPath} replace />;
  }

  // Accès à un musée précis : le slug de l’URL doit correspondre au slug de l’email.
  // On redirige vers la page de login du musée sans déconnecter (évite de casser la session
  // quand on a plusieurs onglets et qu’on se connecte à un autre musée).
  if (museumSlug) {
    const slugFromEmail = getMuseumSlugFromEmail(user.email);
    if (slugFromEmail && slugFromEmail !== museumSlug) {
      return <Navigate to={`/${museumSlug}/login`} replace />;
    }
  }

  return <>{children}</>;
};

